import React from "react";

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
    widthClass?: string;
    allowOverflow?: boolean;
    closeOnOutsideClick?: boolean; // NEW
}

export default function ModalMeet({
    isOpen,
    onClose,
    children,
    widthClass = "max-w-[470px]",
    allowOverflow = true,
    closeOnOutsideClick = false,
}: ModalProps) {
    if (!isOpen) return null;

    return (
        <div
            className="
                fixed inset-0 z-[1000]
                flex items-center justify-center     /* FIXED HERE */
                bg-black/50
                p-4
            "
            onClick={closeOnOutsideClick ? onClose : undefined} 
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className={`
                    w-full ${widthClass}
                    bg-white 
                    rounded-2xl 
                    shadow-xl
                    ${allowOverflow ? 'max-h-[90vh] overflow-y-auto overflow-x-hidden' : ''}
                `}
            >
                {children}
            </div>
        </div>
    );
}
